import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Breadcrumb } from "./breadcrumb/breadcrumb.component";

// ContentHeader component interface
export interface IContentHeader {
  headerTitle: string;
  actionButton?: boolean;
  breadcrumb?: Breadcrumb;
}

@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
})

export class ContentHeaderComponent implements OnInit {
  // input variable
  @Input() contentHeader: IContentHeader;

  constructor(public translate: TranslateService) {}

  ngOnInit() {}
}
